import { MessageCircle, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { PHONES, ADDRESS, MAPS_URL } from "@/data";
import { Reveal, Eyebrow } from "./Reveal";

const PhoneCard = ({ p, i }) => (
  <Reveal delay={i * 0.12}>
    <div data-testid={`contact-card-${p.id}`} className="group relative overflow-hidden rounded-[4px] border border-[#d4af37]/30 bg-[#131315] p-7 sm:p-10">
      <div className="pointer-events-none absolute -right-20 -top-20 h-56 w-56 rounded-full bg-[#d4af37]/10 blur-3xl transition-opacity duration-700 group-hover:opacity-100 opacity-40" />
      <span className="text-xs tracking-[0.3em] uppercase text-[#e8d48f]">Linha {p.id}</span>
      <div data-testid={`contact-number-${p.id}`} className="mt-4 text-4xl sm:text-5xl font-semibold tracking-tight tabular-nums">{p.label}</div>
      <div className="mt-8 grid grid-cols-2 gap-3">
        <a
          data-testid={`contact-whatsapp-${p.id}`}
          href={p.wa}
          target="_blank"
          rel="noopener noreferrer"
          className="gold-bg inline-flex items-center justify-center gap-2 rounded-full py-4 text-sm font-semibold text-black transition-transform duration-300 hover:-translate-y-0.5"
        >
          <MessageCircle className="h-4 w-4" /> WhatsApp
        </a>
        <a
          data-testid={`contact-call-${p.id}`}
          href={p.tel}
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 py-4 text-sm text-white transition-colors hover:border-[#d4af37] hover:text-[#f3e5ab]"
        >
          <Phone className="h-4 w-4" /> Ligar
        </a>
      </div>
    </div>
  </Reveal>
);

export const Contact = () => (
  <section id="contacto" className="relative border-t border-white/10 py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Contacto</Eyebrow>
        <h2 className="mt-6 max-w-4xl font-serif text-5xl leading-[1] sm:text-8xl">
          Marque o seu <span className="gold-text italic">momento</span>.
        </h2>
        <p className="mt-6 max-w-lg text-base text-zinc-300">Escolha um dos nossos números e fale connosco por WhatsApp ou chamada.</p>
      </Reveal>
      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {PHONES.map((p, i) => <PhoneCard key={p.id} p={p} i={i} />)}
      </div>
      <Reveal delay={0.2}>
        <a
          data-testid="contact-maps-link"
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-5 flex flex-col gap-4 rounded-[4px] border border-white/10 p-7 transition-colors hover:border-[#d4af37]/50 sm:flex-row sm:items-center sm:justify-between sm:p-10"
        >
          <div className="flex items-start gap-4">
            <MapPin className="mt-1 h-5 w-5 shrink-0 text-[#d4af37]" />
            <div>
              <div className="text-xs tracking-[0.3em] uppercase text-zinc-400">Morada</div>
              <div className="mt-2 font-serif text-2xl sm:text-3xl">{ADDRESS}</div>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 text-sm text-[#f3e5ab]">
            Abrir no Google Maps <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </a>
      </Reveal>
    </div>
  </section>
);
